export default "__VITE_ASSET__oRbz6Ez3__"